import axios from 'axios'
import { baseMessage } from '@/utils/message'
import store from '@/store/index'
import router from '../router'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  if (config.showLoading) {
    store.commit('TOGGLE_LOADING', true)
  }
  if (store.state.system.token) {
    config.headers['token'] = `${store.state.system.token}`
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    if (store.state.layout.loading && response.config.showLoading) {
      store.commit('TOGGLE_LOADING', false)
    }
    if (response.status === 200 && response.data) {
      if (response.data.code === 1000) {
        return response.data
      } else {
        if (response.data.code === 1001) {
          setTimeout(() => {
            baseMessage('登录超时，请重新登录。', 'error')
            store.dispatch('logout', '')
            router.push('/')
          })
        } else {
          baseMessage(response.data.message || '未知原因错误，请联系管理员。', 'error')
          return Promise.reject(response.data)
        }
      }
    } else {
      baseMessage('系统错误，请联系管理员。', 'error')
      return Promise.reject(response.data)
    }
  },
  error => {
    baseMessage(error.message, 'error')
    return Promise.reject(error)
  })

export default instance

